<template>
  <div class="item-container d-flex flex-column align-center justify-start">
    <div class="item-icon d-flex align-center justify-center">
      <v-progress-circular
        v-if="isDownloading"
        color="blue-grey"
        indeterminate
        :size="40"
        :width="2"
      />

      <v-icon v-if="!isDownloading" size="40" color="blue-grey">{{
        icon
      }}</v-icon>

      <v-tooltip v-if="!isDownloading" top>
        <template v-slot:activator="{ on }">
          <div v-on="on" class="item-overlay" @click="$emit('download')">
            <v-icon size="32" color="white">mdi-download</v-icon>
          </div>
        </template>
        {{ $t('common.button.download') }}
      </v-tooltip>

      <v-icon
        v-if="!readOnly && !isDownloading"
        size="22"
        color="blue-grey darken-2"
        class="delete-button rounded-circle"
        @click="$emit('remove')"
      >
        mdi-close-circle
      </v-icon>
    </div>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <p
          v-on="on"
          v-snip="2"
          class="mt-1 mb-0 caption font-weight-medium blue-grey--text text--darken-3 item-name text-center"
        >
          {{ shortenedFileName }}
        </p>
      </template>
      {{ fileName }}
    </v-tooltip>
  </div>
</template>

<script>
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'AttachmentItem',

  mixins: [mixin],

  props: {
    attachment: {
      type: Object,
      required: true,
    },

    readOnly: Boolean,

    isDownloading: Boolean,
  },

  computed: {
    fileName() {
      return this.attachment?.media?.originalFileName || ''
    },

    shortenedFileName() {
      if (!this.fileName) return ''

      const maxLength = 20
      if (this.fileName.length <= maxLength) return this.fileName

      const ellipsis = '...'
      const charsToShow = maxLength - ellipsis.length
      const frontChars = Math.ceil(charsToShow / 2)
      const backChars = Math.floor(charsToShow / 2)
      return `${this.fileName.slice(
        0,
        frontChars
      )}${ellipsis}${this.fileName.slice(this.fileName.length - backChars)}`
    },

    icon() {
      const extension = this.attachment?.media?.fileExtension
      return this.getFileIconByExtension(extension)
    },
  },
}
</script>

<style lang="scss" scoped>
.item-container {
  width: 80px;
}

.item-icon {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 12px;
  border: 1px solid var(--v-blue-grey-lighten1);
  cursor: pointer;

  .item-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s;
    z-index: 1;
    cursor: pointer;
  }

  &:hover {
    .item-overlay {
      opacity: 1;
    }
  }
}

.item-name {
  max-width: 80px;
}

.delete-button {
  width: 24px !important;
  height: 24px !important;
  position: absolute;
  top: -6px;
  right: -6px;
  z-index: 2;

  i {
    font-size: 16px !important;
  }
  background-color: white;
}
</style>
